module.exports = "/_next/static/festival-cf.css?fek2xzo";